<template>
  <div class="p-4 text-center text-muted">
    Redirection vers la création d'achat…
  </div>
</template>

<script>
export default {
  name: "PurchasesItemsCreateRedirect",
  beforeMount() {
    this.$router.replace({
      name: "purchases-create",
      query: this.$route.query || {},
    });
  },
};
</script>
